<template>
  <div id="dedicationInput" class="menuSection">
    <h2 class="optionTitle">{{ $t('caption') }}</h2>
    <h3>{{ $t('title') }}</h3>
    <TextInput
      v-model="posterState.heading"
      :text="posterState.heading"
      :max-chars-per-line="40"
      :name="'heading'"
    />
    <h3 class="optionTitle">{{ $t('dedication') }}</h3>
    <p class="optionDescription">
      {{ $t('dedicationNote') }}
    </p>
    <TextInput
      v-model="posterState.dedication"
      :text="posterState.dedication"
      v-bind:placeholder="$t('optional')"
      :max-lines="3"
      :name="'dedication'"
    />

    <h3 class="optionTitle">{{ $t('heading') }}</h3>
    <TextInput
      v-model="posterState.date"
      :text="posterState.date"
      v-bind:placeholder="$t('optional')"
      :name="'title'"
    />
  </div>
</template>

<script>
import TextInput from './TextInput.vue'

export default {
  name: 'DedicationInput',
  props: {
    posterState: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextInput,
  },
}
</script>
